import { useGlobalContext } from "../../../../../Context/Context";
import { useState } from "react";
import Button from "../../../../Custom/Button/Button";
import sortImg from "../../../../../picture/Sort.png";
import redniBrojeviImg from "../../../../../picture/redniBrojevi.png";
import sumaImg from "../../../../../picture/suma.png";
import editImg from "../../../../../picture/edit.png";
import EditRiziciModal from "./EditRiziciModal";

const styles = {
  cell: {
    padding: "5px",
    textAlign: "center",
  },
  smallCell: {
    width: "40px",
    textAlign: "center",
  },
  icon: {
    width: "30px",
    height: "30px",
  },
};

function RadnaMestaTabela({
  radnaMesta,
  setRadnaMesta,
  isCheckedSort,
  setIsCheckedSort,
  onRefresh
}) {
  const [isCheckedRedniBrojevi, setIsCheckedRedniBrojevi] = useState(false);

  const [editRadnoMesto, setEditRadnoMesto] = useState(null);

  const { dictionary } = useGlobalContext();

  const handleCheckRedniBrojevi = () => {
    setIsCheckedRedniBrojevi((prev) => !prev);
  };
  const handleCheckSort = () => {
    setIsCheckedSort((prev) => !prev);
  };

  const handleOpenEdit = (radnoMesto) => {
    setEditRadnoMesto(radnoMesto);
  };

  const handleCancelEdit = () => {
    setEditRadnoMesto(null);
  };

  const handleConfirmEdit = (newData) => {
    setRadnaMesta((prev) =>
      prev.map((rm) => (rm.id === newData.id ? newData : rm)),
    );
    setEditRadnoMesto(null);
  };

  return (
    <>
      <table style={{ width: "100%" }}>
        <tr>
          <th style={{ width: "80px" }}>
            <div style={{ display: "flex" }}>
              <div onClick={handleCheckSort}>
                <Button active={isCheckedSort}>
                  <img
                    src={sortImg}
                    style={{ width: "40px", height: "30px" }}
                  />
                </Button>
              </div>
              <div onClick={handleCheckRedniBrojevi}>
                <Button active={isCheckedRedniBrojevi}>
                  <img
                    src={redniBrojeviImg}
                    style={{ width: "40px", height: "30px" }}
                  />
                </Button>
              </div>
            </div>
          </th>
          <th style={{ ...styles.cell, width: "40%" }}>
            {dictionary["nazivRadnogMesta"]}
          </th>
          <th style={styles.cell}>{dictionary["rizik"]}</th>
          <th style={styles.cell}>{dictionary["sprema"]}</th>
          <th style={styles.cell}>{dictionary["iskustvo"]}</th>
          <th style={styles.cell}>{dictionary["uslovi"]}</th>
          <th style={styles.cell}>
            <img src={sumaImg} style={{ width: "25px" }} />
          </th>
          <th style={styles.smallCell}></th>
        </tr>
        {radnaMesta.map((radnoMesto, index) => (
          <tr key={radnoMesto.id}>
            <td
              style={{ padding: "5px" }}
            >{`${isCheckedRedniBrojevi ? radnoMesto.redniBroj : index + 1}.`}</td>
            <td style={styles.cell}>{radnoMesto.naziv}</td>
            <td style={styles.cell}>
              {radnoMesto.rizik === "NEDEFINISANO" ? "-" : radnoMesto.rizik}
            </td>
            <td style={styles.cell}>{radnoMesto.sprema}</td>
            <td style={styles.cell}>{radnoMesto.iskustvo}</td>
            <td style={styles.cell}>{radnoMesto.posebniUslovi.length}</td>
            <td style={styles.cell}>{radnoMesto.suma}</td>
            <td
              onClick={() => handleOpenEdit(radnoMesto)}
              style={{ ...styles.smallCell, cursor: "pointer" }}
            >
              <img src={editImg} style={{ width: "25px" }} />
            </td>
          </tr>
        ))}
      </table>

      {editRadnoMesto && (
        <EditRiziciModal
          handleConfirm={handleConfirmEdit}
          handleCancel={handleCancelEdit}
          initialData={editRadnoMesto}
          onRefresh={onRefresh} 
        />
      )}
    </>
  );
}

export default RadnaMestaTabela;
